import React from "react";
import { connect } from "react-redux";
import {
  Row,
  Modal,
  ModalBody,
  ModalHeader,
  Button,
  CardFooter,
  CardHeader,
  CardBody,
  Card,
} from "reactstrap";
import { schoolActions } from "../actions";
import { personasActions } from "../../personas/actions";

import {
  EnrollRequirement,
  EnrollHeader,
} from "../components/EnrollComponents";

var viewActions = require("store/view.actions");

var reports = require("../reports");

class EnrollPage extends React.Component {
  printReports = [
    {
      id: "CONTRATO",
      label: "Contrato de matriculación",
      action: this.printContract.bind(this),
    },
    { id: "NOTA", label: "Nota a padres", action: this.printNota.bind(this) },
  ];

  componentDidMount() {
    this.props.getPersona(this.props.token, this.props.match.params.personaID);
    this.props.getEnrollFile(
      this.props.token,
      this.props.match.params.personaID,
      this.props.nextCalendarID
    );
    this.props.setMainTitle("Matriculación", this.printReports);
  }

  constructor(props) {
    super(props);
    this.state = {
      uploadImage: false,
      zoomImage: false,
      selectedReq: {},
      imgFile: null,
      selectedFile: "",
      isFilePicked: false,
    };
  }

  printContract() {
    reports.getReport(
      this.props.token,
      this.props.nextCalendarID,
      this.props.persona.persona_id,
      "CONTRATO"
    );
  }
  printNota() {
    reports.getReport(
      this.props.token,
      this.props.nextCalendarID,
      this.props.persona.persona_id,
      "NOTA"
    );
  }

  changeHandler = (event) => {
    this.setState({
      selectedFile: event.target.files[0],
      isFilePicked: true,
      imgFile: URL.createObjectURL(event.target.files[0]),
    });
  };

  toggleUploadImage(val, req) {
    this.setState({
      selectedFile: null,
      isFilePicked: false,
      imgFile: null,
      uploadImage: val,
      selectedReq: req,
    });
  }
  toggleZoomImage(val, req) {
    this.setState({ zoomImage: val, selectedReq: req });
  }

  handleSubmission = (req) => {
    const formData = new FormData();
    formData.append("file", this.state.selectedFile);
    this.props.uploadEnrollFile(
      this.props.token,
      this.state.selectedReq.persona_id,
      this.state.selectedReq.req_id,
      formData
    );
  };

  render() {
    return (
      <>
        <div className="content">
          <Modal
            toggle={() => this.toggleZoomImage(!this.state.zoomImage, {})}
            isOpen={this.state.zoomImage}
            size="lg"
          >
            <ModalHeader
              toggle={() => this.toggleZoomImage(!this.state.zoomImage, {})}
            ></ModalHeader>
            <ModalBody>
              <img
                src={this.state.selectedReq.file_url}
                alt={this.state.selectedReq.file_url}
              />
            </ModalBody>
          </Modal>

          <Modal
            toggle={() => this.toggleUploadImage(!this.state.uploadImage, {})}
            isOpen={this.state.uploadImage}
            size="lg"
          >
            <ModalBody>
              <Card>
                <CardHeader>
                  <span className="h4">{this.state.selectedReq.title}</span>
                  <br />
                  <span className="">{this.state.selectedReq.description}</span>
                </CardHeader>
                <CardBody>
                  {this.state.isFilePicked ? (
                    <img
                      src={this.state.imgFile}
                      alt={this.state.imgFile}
                      height="400"
                    />
                  ) : (
                    <input
                      type="file"
                      name="file"
                      onChange={this.changeHandler}
                    />
                  )}

                  {/* <QRCode value={ this.state.selectedReq.school_id + "$&" +
                                    this.state.selectedReq.persona_id + "$&" +
                                    this.state.selectedReq.calendar_id + "$&" +
                                    this.state.selectedReq.req_id + "$&" +
                                    this.state.selectedReq.description } /> */}
                </CardBody>
                <CardFooter>
                  <hr />
                  {this.state.isFilePicked ? (
                    <>
                      {this.props.view.loadingModules.uploadEnrollFile ? (
                        <Button color="success" size="sm" disabled={true}>
                          <i className="nc-icon nc-refresh-69  fa-spin" />
                        </Button>
                      ) : (
                        <>
                          <Button
                            color="success"
                            size="sm"
                            onClick={() => this.handleSubmission()}
                          >
                            Confirmar
                          </Button>
                          &nbsp;
                        </>
                      )}
                    </>
                  ) : (
                    <></>
                  )}
                  <Button
                    color="warning"
                    size="sm"
                    onClick={() =>
                      this.toggleUploadImage(!this.state.uploadImage, {})
                    }
                  >
                    {this.props.view.loadingModules.uploadOK
                      ? "Cerrar"
                      : "Cancelar"}
                  </Button>
                </CardFooter>
              </Card>
            </ModalBody>
            {/* } */}
          </Modal>

          <Row>
            <EnrollHeader
              persona={this.props.persona}
              course={this.props.enrollFile.currentCourse}
              enrollStudentCourse={this.props.enrollStudentCourse}
            />
            {this.props.enrollFile.requirements &&
              this.props.enrollFile.requirements.map((req) => {
                return (
                  <EnrollRequirement
                    req={req}
                    upload={this.toggleUploadImage.bind(this)}
                    zoom={this.toggleZoomImage.bind(this)}
                    deleteFile={this.props.deleteEnrollFile}
                  />
                );
              })}
          </Row>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    token: state.auth.session.jwt_token,
    currentCalendarID: state.school.currentCalendarID,
    view: state.view,
    nextCalendarID: "20260000-5026-4B33-9EAA-000000002026",
    enrollFile: state.school.enrollFile,
    persona: state.personas.persona,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setMainTitle: (title, menu) => {
      dispatch(viewActions.setMainTitle(title, menu));
    },
    getEnrollFile: (token, personaID, calendarID) => {
      dispatch(schoolActions.getEnrollFile(token, personaID, calendarID));
    },
    getPersona: (token, personaID) => {
      dispatch(personasActions.getPersona(token, personaID));
    },
    deleteEnrollFile: (token, personaID, reqID, fileID) => {
      let nextCalendarID = "20260000-5026-4B33-9EAA-000000002026";
      dispatch(
        schoolActions.deleteEnrollFile(
          token,
          personaID,
          nextCalendarID,
          reqID,
          fileID
        )
      );
    },
    uploadEnrollFile: (token, personaID, reqID, data) => {
      let nextCalendarID = "20260000-5026-4B33-9EAA-000000002026";
      dispatch(
        schoolActions.uploadEnrollFile(
          token,
          personaID,
          nextCalendarID,
          reqID,
          data
        )
      );
    },
    enrollStudentCourse: (token, personaID, courseID) => {
      let nextCalendarID = "20260000-5026-4B33-9EAA-000000002026";
      dispatch(
        schoolActions.enrollStudentCourse(
          token,
          personaID,
          nextCalendarID,
          courseID
        )
      );
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EnrollPage);
